module.exports = __webpack_public_path__ + "static/media/fat.12680b1a.svg";